import React, { useState } from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Objection-handling at the point of decision — the online stand-in for the
// rep answering questions live. Every answer here is supportable from the
// deck / known facts. Price-dependent Q&As are intentionally omitted until
// pricing is finalized (see TODO).
const FAQ = () => {

    const [openIndex, setOpenIndex] = useState(0);

    const faqs = [
        {
            q: 'Are there any monthly fees or subscriptions?',
            a: 'No. You own the system outright — there are no monthly monitoring fees. You get text, email, and app alerts at no ongoing cost.',
        },
        {
            q: 'What comes in the system?',
            a: 'A Smart Hub (the brains of the network), one or more wireless Water Sensors you place wherever water runs, and the Bedside Control Center with a mattress shaker that can wake you at night.',
        },
        {
            q: 'Do I need a professional to install it?',
            a: 'No. The sensors are wireless and portable — place them under sinks, by the water heater, behind the fridge — and the system is up and running in minutes.',
        },
        {
            q: 'What happens when a leak is detected?',
            a: 'You get an instant alert by text, email, and in the app — and so do up to 8 emergency contacts you choose. The alert names the exact location, so you know it\'s the kitchen sink or the laundry room before it becomes real damage.',
        },
        {
            q: 'Does it detect freezing too?',
            a: 'Yes. The network detects both flooding and freezing conditions, so you\'re covered against burst-pipe risk as well as leaks.',
        },
        {
            q: 'Will it still work if I move?',
            a: 'Yes. Because the sensors are wireless and portable, the whole system comes with you — unlike wired-in systems that stay with the house.',
        },
        {
            q: 'Is this a product of the USA?',
            a: 'Yes — every device is designed and engineered in the U.S.A.',
        },
        {
            q: 'What is your return policy?',
            a: 'You can return your system within 14 days for a refund if it isn\'t the right fit. Every device is also backed by our manufacturer warranty.',
        },
        {
            q: 'How much does shipping cost?',
            a: 'Shipping is free.',
        },
        // TODO: add a pricing / "how many sensors do I need?" Q&A once pricing
        // and the starter-kit bundle are finalized.
    ];

    return (
        <section id={'faq'} style={{
            width: '100%',
            backgroundColor: Appearance.colors.offWhite
        }}>
            <div style={{
                maxWidth: Appearance.layout.readableWidth,
                margin: '0 auto',
                padding: Appearance.layout.sectionPadding(),
            }}>

                <div style={{ textAlign: 'center', marginBottom: Utils.isMobile() ? 36 : 48 }}>
                    <span style={{ ...Appearance.textStyles.label(), marginBottom: 14, display: 'block' }}>
                        {'Questions'}
                    </span>
                    <h2 style={Appearance.textStyles.sectionHeading()}>
                        {'Everything you\'re wondering'}
                    </h2>
                </div>

                <div>
                    {faqs.map((item, index) => {
                        let open = openIndex === index;
                        return (
                            <div key={index} style={{
                                borderBottom: `1px solid ${Appearance.colors.border()}`,
                                borderTop: index === 0 ? `1px solid ${Appearance.colors.border()}` : 'none',
                            }}>
                                {/* Question row */}
                                <div
                                    onClick={() => setOpenIndex(open ? -1 : index)}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        gap: 20,
                                        padding: Utils.isMobile() ? '20px 4px' : '24px 8px',
                                        cursor: 'pointer',
                                    }}>
                                    <span style={{
                                        fontFamily: Appearance.fonts.body,
                                        fontWeight: 600,
                                        fontSize: Utils.isMobile() ? 15 : 17,
                                        lineHeight: 1.35,
                                        color: open ? Appearance.colors.primary() : Appearance.colors.text(),
                                        transition: 'color 0.2s ease',
                                    }}>
                                        {item.q}
                                    </span>
                                    <div style={{
                                        width: 28,
                                        height: 28,
                                        flexShrink: 0,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                        transition: 'transform 0.25s ease',
                                    }}>
                                        <i className={'fas fa-chevron-down'} style={{
                                            fontSize: 14,
                                            color: open ? Appearance.colors.primary() : Appearance.colors.lightGrey,
                                        }} />
                                    </div>
                                </div>

                                {/* Answer — smooth reveal */}
                                <div style={{
                                    maxHeight: open ? 400 : 0,
                                    opacity: open ? 1 : 0,
                                    overflow: 'hidden',
                                    transition: 'max-height 0.3s ease, opacity 0.3s ease',
                                }}>
                                    <p style={{
                                        ...Appearance.textStyles.body(),
                                        margin: 0,
                                        padding: Utils.isMobile() ? '0 4px 22px 4px' : '0 60px 26px 8px',
                                    }}>
                                        {item.a}
                                    </p>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default FAQ;
